exports.iframeResizer = require('./iframeResizer');
exports.iframeResizerContentWindow = require('./iframeResizer.contentWindow');



//////////////////
// WEBPACK FOOTER
// ./~/iframe-resizer/js/index.js
// module id = 32
// module chunks = 0